import { fileShareSharedFolderAddOnAdded } from '@wix/bi-logger-wixlabs-users/v2';
import { fileShareSharedFolderAddOnAddedParams } from '@wix/bi-logger-wixlabs-users/v2/types';
import { PermissionType } from '../biService.types';

export const biSharedFolderAddOnsAdded = (
  props: PermissionType<fileShareSharedFolderAddOnAddedParams>,
) => {
  const { logger, ...params } = props;
  logger?.report(fileShareSharedFolderAddOnAdded({ ...params }));
};
